import { api } from "../../api/apiSlice";

export const usersApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getUsers: builder.query({
      query: (params) => ({ url: "/users", params }),
      providesTags: (result) =>
        result
          ? [
              ...result.map((u) => ({ type: "Users", id: u.userId })),
              { type: "Users", id: "LIST" },
            ]
          : [{ type: "Users", id: "LIST" }],
    }),
    getUser: builder.query({
      query: (userId) => ({ url: `/users/${userId}` }),
      providesTags: (result, error, userId) => [{ type: "Users", id: userId }],
    }),
    createUser: builder.mutation({
      query: (body) => ({ url: "/users", method: "POST", data: body }),
      invalidatesTags: [{ type: "Users", id: "LIST" }],
    }),
    updateUser: builder.mutation({
      query: ({ userId, ...body }) => ({
        url: `/users/${userId}`,
        method: "PUT",
        data: body,
      }),
      invalidatesTags: (result, error, { userId }) => [
        { type: "Users", id: userId },
        { type: "Users", id: "LIST" },
      ],
    }),
    resetUserPassword: builder.mutation({
      query: ({ userId, password }) => ({
        url: `/users/${userId}/password`,
        method: "POST",
        data: { password },
      }),
    }),
    assignUserRole: builder.mutation({
      query: ({ userId, roleId }) => ({
        url: `/users/${userId}/roles/${roleId}`,
        method: "POST",
      }),
      invalidatesTags: (result, error, { userId }) => [
        { type: "Users", id: userId },
      ],
    }),
    removeUserRole: builder.mutation({
      query: ({ userId, roleId }) => ({
        url: `/users/${userId}/roles/${roleId}`,
        method: "DELETE",
      }),
      invalidatesTags: (result, error, { userId }) => [
        { type: "Users", id: userId },
      ],
    }),
    assignUserBranch: builder.mutation({
      query: ({ userId, branchId }) => ({
        url: `/users/${userId}/branches/${branchId}`,
        method: "POST",
      }),
      invalidatesTags: (result, error, { userId }) => [
        { type: "Users", id: userId },
      ],
    }),
    removeUserBranch: builder.mutation({
      query: ({ userId, branchId }) => ({
        url: `/users/${userId}/branches/${branchId}`,
        method: "DELETE",
      }),
      invalidatesTags: (result, error, { userId }) => [
        { type: "Users", id: userId },
      ],
    }),
    grantUserPermissionOverride: builder.mutation({
      query: ({ userId, permissionId, isGranted, reason }) => ({
        url: `/users/${userId}/permission-overrides`,
        method: "POST",
        data: { permissionId, isGranted, reason },
      }),
      invalidatesTags: (result, error, { userId }) => [
        { type: "Users", id: userId },
      ],
    }),
    clearUserPermissionOverride: builder.mutation({
      query: ({ userId, permissionId }) => ({
        url: `/users/${userId}/permission-overrides/${permissionId}`,
        method: "DELETE",
      }),
      invalidatesTags: (result, error, { userId }) => [
        { type: "Users", id: userId },
      ],
    }),
  }),
  overrideExisting: false,
});

export const {
  useGetUsersQuery,
  useGetUserQuery,
  useCreateUserMutation,
  useUpdateUserMutation,
  useResetUserPasswordMutation,
  useAssignUserRoleMutation,
  useRemoveUserRoleMutation,
  useAssignUserBranchMutation,
  useRemoveUserBranchMutation,
  useGrantUserPermissionOverrideMutation,
  useClearUserPermissionOverrideMutation,
} = usersApi;
